import React from "react"
import { MyTableFilterControlHelpers } from "@macashipo/mlib"

const MyFilterControlSelectMulti = React.lazy(
  () => import("./Types/select_multi")
)

const List = {
  select_multi: MyFilterControlSelectMulti,
}
const MyTableFilterControlOne = {
  init() {
    MyTableFilterControlHelpers.addTypesFromListLazy(List)
  },
}

export default MyTableFilterControlOne
